import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import Chart from './Chart'
import ComplianceTypeDropdown from '../../_shared/ComplianceTypeDropdown'
import PeriodDescription from '../../_shared/PeriodDescription'
import PeriodicNonCompliancesLoader from './_load/PeriodicNonCompliancesLoader'
import PerspectiveDropdown from '../../_shared/PerspectiveDropdown'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <Grid justify="space-between" gap={1}>
        <Col>
          <Title size="h5" noMargin>
            {widget.name}
          </Title>
          <PeriodDescription />
        </Col>
        <Col flex={1} />
        <PerspectiveDropdown />
        <ComplianceTypeDropdown />
      </Grid>
      <PeriodicNonCompliancesLoader>
        <Chart widget={widget} />
      </PeriodicNonCompliancesLoader>
    </WidgetWrapper>
  )
}

export default Widget
